import { useQuery } from "react-query";
import { getPreview } from "../../../services/api/wristbands";

export const WRISTBAND_PREVIEW_QUERY_KEY = "Q_WRISTBAND_PREVIEW";

export const useWristbandPreview = (id: number) => {
  return useQuery([WRISTBAND_PREVIEW_QUERY_KEY, id], () => getPreview(id));
};
